import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@deseretbook/react-ui'

/**
 * Component to show the featured content on Video Discovery Home page
 *
 * @param {object} item Featured Sku for video discovery home from
 *
 * @returns {function} React component
 */
const Featured = ({ item }) => {
  const { id, image, variant } = item

  return <div style={{ background: image }} key={`Featured-${id}`}></div>
}

Featured.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    variant: PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
}

export default Featured
